export const ADD_CREATE_SURVEYS = 'ADD_CREATE_SURVEYS';
